// extracted by mini-css-extract-plugin
export default {"description":"style_description__JCGJ4","fade-in":"style_fade-in__Nzrte","top":"style_top__9G1T1","image":"style_image__4h1Nw"};